import './modal-popupfilter.scss';
import { Alert, Button } from '@piggytechng/component-library';
import dayjs from 'dayjs';
import ModalBase from '.';

import { DateFilterModalProps, DateReference } from '../../types';
// import InputCalendar from "../Inputcalendar";
// import closeIcon from '../../../public/assets/icons/modal-close.svg';

import { useEffect, useRef, useState } from 'react';
import { OverideButtonStyle, useOutsideClick } from '../../helpers/utils';

const DateFilter = ({
  children,
  setParams,
  getData,
  params,
  interestAccrued = false,
  showDropdown,
  setShowDropdown,
}: DateFilterModalProps) => {
  const [nowActive, setNowActive] = useState(false);
  const [customRangeValue, setCustomRangeValue] = useState(['', '']);
  const [showCustomRange, setShowCustomRange] = useState(false);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const actionRef = useRef<HTMLDivElement>(null);

  const currentDay = dayjs().startOf('day').format('YYYY-MM-DD');
  const thisMonthStart = dayjs().startOf('month').format('YYYY-MM-DD');
  const thisWeek = dayjs().startOf('week').format('YYYY-MM-DD');
  const thisWeekEnd = dayjs().endOf('week').format('YYYY-MM-DD');
  // const lastWeek = dayjs().startOf('week').subtract(1, 'week').format('YYYY-MM-DD');
  // const lastWeekEnd = dayjs().endOf('week').subtract(1, 'week').format('YYYY-MM-DD');
  const lastMonth = dayjs().startOf('month').subtract(1, 'month').format('YYYY-MM-DD');
  const lastMonthEnd = dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
  const thisMonth = dayjs().startOf('month').format('YYYY-MM-DD');
  const thisMonthEnd = dayjs().endOf('month').format('YYYY-MM-DD');

  const dateReferences: Array<DateReference> = [
    {
      name: interestAccrued ? 'This Month' : 'All Time',
      value: interestAccrued ? [thisMonthStart, currentDay] : ['', ''],
    },
    {
      name: 'Today',
      value: [currentDay, currentDay],
    },
    {
      name: 'This Week',
      value: [thisWeek, thisWeekEnd],
    },
    {
      name: 'This Month',
      value: [thisMonth, thisMonthEnd],
    },
    {
      name: 'Last Month',
      value: [lastMonth, lastMonthEnd],
    },
  ];

  const formatTime = (time: string, which: 'start' | 'end') => {
    switch (which) {
      case 'start':
        return time;
      case 'end':
        return time;
      default:
        return time;
    }
  };

  const selectDate = (date: any) => {
    const { name, value } = date;

    if (name === 'Custom') {
      let start: string | undefined = undefined,
        end: string | undefined = undefined;
      value[0] === 'start' ? (start = value[1]) : (end = value[1]);

      const newStartDate = start ?? params?.start_date?.date ?? '';
      const newEndDate = end ?? params?.end_date?.date ?? '';

      setParams?.({
        ...params,
        [`${date.which}_date`]: {
          name: 'Custom',
          date: formatTime(date.which === 'start' ? newStartDate : newEndDate, date.which),
        },
        isTimeFilterApplied: true,
      });

      if (date.which === 'start') {
        setCustomRangeValue([formatTime(newStartDate, 'start'), formatTime(customRangeValue[1] ?? newEndDate, 'end')]);
      } else {
        setCustomRangeValue([formatTime(customRangeValue[0] ?? newStartDate, 'start'), formatTime(newEndDate, 'end')]);
      }
    } else {
      const updatedParams = {
        ...params,
        start_date: {
          name,
          date: value[0] ? formatTime(value[0], 'start') : '',
        },
        end_date: {
          name,
          date: value[1] ? formatTime(value[1], 'end') : '',
        },
        isTimeFilterApplied: true,
      };
      setParams?.(updatedParams);
    }

    setShowDropdown?.(false);

    // this is to show the custom range modal
    if (name === 'Custom' && !date.which) {
      setCustomRangeValue([
        formatTime(params?.start_date?.date ?? '', 'start'),
        formatTime(params?.end_date?.date ?? '', 'end'),
      ]);
      setShowCustomRange(true);
    }
  };

  const selectRangeDone = () => {
    if (params?.start_date?.date !== '' && params?.end_date?.date !== '') {
      setShowCustomRange(false);
      nowActive &&
        getData?.({
          isEmpty: params?.start_date?.date === '' && params?.end_date?.date === '',
        });
    } else {
      Alert.error('Please select a valid date range');
    }
  };

  useEffect(() => {
    if (showCustomRange) return;
    nowActive &&
      getData?.({
        isEmpty: params?.start_date?.date === '' && params?.end_date?.date === '',
      });
  }, [params?.start_date, params?.end_date]);

  useOutsideClick(dropdownRef, setShowDropdown || (() => {}), actionRef);

  return (
    <div className="popup-filter" onClick={() => setNowActive(true)}>
      <div className="popup-filter__action" onClick={() => setShowDropdown?.(!showDropdown)} ref={actionRef}>
        {children}
      </div>
      {showDropdown && (
        <div className={`popup-filter__dropdown`} ref={dropdownRef}>
          <div className="body">
            {dateReferences.map((d) => (
              <div
                className={`option date ${d.name === params?.start_date?.name ? 'selected' : ''}`}
                key={d.name}
                onClick={() => selectDate(d)}
              >
                <span>{d.name}</span>{' '}
                <span className="sub">
                  {d.value[0] ? dayjs(d.value[0]).format('MMM D') : ''}
                  {d.value[1] ? ' - ' + dayjs(d.value[1]).format('MMM D') : ''}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <ModalBase modalIsOpen={showCustomRange} setIsOpen={setShowCustomRange}>
        <div className="popup-filter-modal">
          <div className="popup-filter-modal__header">
            <h3>Select Date Range </h3>
            <button onClick={() => setShowCustomRange(false)}>{/* <img src={closeIcon} /> */}</button>
          </div>
          <br />
          <div className="popup-filter-modal__inputs">
            {/* <InputCalendar
              label="Start date"
              leftStart
              handleChange={(e) => selectDate({ name: 'Custom', value: ['start', e.target.value], which: 'start' })}
              // Set min date to Jan 2024
              minDate={new Date(2024, 0, 1)}
            />

            <InputCalendar
              label="End date"
              disabled={!params.start_date.date}
              handleChange={(e) => selectDate({ name: 'Custom', value: ['end', e.target.value], which: 'end' })}
              minDate={params.start_date.date && new Date(params.start_date.date)}
              maxDate={endDateToday && new Date()}
            /> */}
          </div>
          <div className="popup-filter-modal__actions">
            <Button
              {...OverideButtonStyle}
              color="#F1F5F9"
              style={{ ...OverideButtonStyle.style, color: '#000' }}
              onClick={() => {
                setShowCustomRange(false);
              }}
            >
              Cancel
            </Button>
            <Button
              {...OverideButtonStyle}
              onClick={selectRangeDone}
              style={{ ...OverideButtonStyle.style, color: 'white' }}
            >
              Apply
            </Button>
          </div>
        </div>
      </ModalBase>
    </div>
  );
};

export default DateFilter;
